// Whether the Case detail is shown in a panel beside another screen (not in
// /me/cases). In a panel the detail closes itself instead of going to the list.
import { m } from "@trameria/i18n";
import { createContext, useContext } from "react";
import { useSideView } from "../shell/side-view";
import { IconButton } from "../ui/button";
import { Icon } from "../ui/icon";

export interface CasePeek {
  close(): void;
}

export const CasePeekContext = createContext<CasePeek | null>(null);

export const useCasePeek = () => useContext(CasePeekContext);

/**
 * The panel's close button; nothing when the detail is not in a panel, or in a
 * side view (its header already ends with the side view's close).
 */
export function PeekClose() {
  const peek = useCasePeek();
  const side = useSideView();
  if (!peek || side) return null;
  return (
    <IconButton label={m.cases_panel_close()} onClick={peek.close}>
      <Icon kind="close" size={14} />
    </IconButton>
  );
}
